export enum FLOW_AREA {
  SIMULACION ="simulacion",
  CONTRATACION ="contratacion",
};

export type FlowAreaType = FLOW_AREA.SIMULACION | FLOW_AREA.CONTRATACION;
